import React from "react"
import { useSelector } from "react-redux"

import { haveAuth } from "utils"
import HoldButton from "./HoldButton"
import RetrieveButton from "./RetrieveButton"
import classes from "./index.module.scss"

const FoodSidebarHoldAndRetrieveButtons = () => {
  const orderForEditDetails =
    useSelector(state => !!state.orderForEditDetails)

  const hideButtons =
    orderForEditDetails

  if (hideButtons) return null

  if (!haveAuth(["holdAndRetrieve"])) return null

  return (
    <div className={classes["row"]}>
      <HoldButton />

      <RetrieveButton />
    </div>
  )
}

export default React.memo(FoodSidebarHoldAndRetrieveButtons)